/**
 * Build/version info baked in at CI build time. The deploy workflows inject
 * REACT_APP_BUILD_VERSION as `yyyyMMdd_HHmmss_<version>` (deploy timestamp + version),
 * which auto-iterates on every staging/main deploy — so the footer reveals whether an
 * environment is running an older or newer build. Falls back to 'dev' locally.
 */
export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || 'dev';
export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
export const APP_ENV = process.env.REACT_APP_ENV || 'local';
